import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FEATURE_GROUPS, SIGNUP_PATH, EFFY_ORDER_PRODUCT } from './seoPages';
import { SeoHead, ProductBreadcrumb, FaqSection, SignupCta } from './SeoShared';
import '../products/EffyOrder.css';
import './SeoPages.css';

const FAQS = [
  { question: 'Which businesses is Effy Order for?', answer: 'Effy Order is built for small and growing retail and wholesale businesses in India that need GST billing, inventory, orders, purchases and payments in one place.' },
  { question: 'Do I need to install anything?', answer: 'No. Effy Order runs in the browser on desktop, tablet and mobile. Sign up and start billing right away.' },
  { question: 'Is there a free trial?', answer: 'Yes. Plans start at ₹199/month and come with a 30-day free trial.' },
];

// /products/effy-order/features — every Effy Order capability on one page, each linking to its
// detailed landing page where one exists. Acts as the hub for internal linking.
export default function FeaturesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="oi-page-v2">
      <SeoHead
        path={EFFY_ORDER_PRODUCT.featuresPath}
        title="Effy Order Features – GST Billing, Inventory, Orders & Purchases | EffyVenture"
        description="All Effy Order features in one place: GST billing, invoices, quotations, delivery challans, inventory with low stock alerts, barcodes, purchase orders, payments, credit notes and GST reports."
        breadcrumbName="Features"
        product={EFFY_ORDER_PRODUCT}
        faqs={FAQS}
      />

      <section className="oi-hero-v2 seo-hero--center">
        <div className="seo-hero__center">
          <ProductBreadcrumb product={EFFY_ORDER_PRODUCT} current="Features" />
          <div className="oi-badge-v2">Effy Order features</div>
          <h1 className="oi-hero-v2__title">
            Everything your business needs to <span className="text-gradient">bill, stock and grow.</span>
          </h1>
          <p className="oi-hero-v2__subtitle">
            GST billing, inventory, orders, purchases, payments and reports — one simple app that works on desktop, tablet and mobile.
          </p>
          <div className="oi-hero-v2__actions seo-hero__actions">
            <Link to={SIGNUP_PATH} className="btn-v2 btn-v2--primary">Try it free</Link>
            <Link to="/effy-order-pricing" className="btn-v2 btn-v2--secondary">View pricing</Link>
          </div>
        </div>
      </section>

      <div className="seo-groups">
        {FEATURE_GROUPS.map((group) => (
          <section key={group.title} className="seo-group">
            <h2 className="seo-group__title">
              <span className="seo-group__icon" aria-hidden="true">{group.icon}</span>
              {group.title}
            </h2>
            <div className="seo-group__grid">
              {group.items.map((item) => (
                <FeatureCard key={item.name} item={item} />
              ))}
            </div>
          </section>
        ))}
      </div>

      <FaqSection faqs={FAQS} />
      <SignupCta />
    </div>
  );
}

function FeatureCard({ item }) {
  const body = (
    <>
      <h3 className="seo-card__name">{item.name}</h3>
      <p className="seo-card__text">{item.text}</p>
    </>
  );

  if (item.link) {
    return (
      <Link to={item.link} className="seo-card seo-card--link">
        {body}
        <span className="seo-card__more">Learn more →</span>
      </Link>
    );
  }
  return <div className="seo-card">{body}</div>;
}
